import React, { useState, useCallback, useEffect, createContext } from "react";
import styled from "styled-components";
import { useTable, useRowSelect, useSortBy } from "react-table";
import TripAndCharge from "components/trip_and_charge_component/TripAndCharge";
import styles from "../mychargers.module.scss";
import cn from "classnames";
// import { Link } from 'react-router-dom';
import BatteryProgress from "../echarts/BatteryProgress";
import {
  getRequest,
  postRequest,
  deleteRequest,
} from "../../services/axiosBaseClient";
import ConfrimBox from "../commonComponents/confirmBox";
// import { useDispatch } from "react-redux";
import { parse } from "query-string";
// import TableScrollbar from 'react-table-scrollbar';
//import makeData from './makeData'
import { addChargerId } from "redux/chargerTableSlice";
import { useLocation } from "react-router-dom";

const Styles = styled.div`
  padding: 0rem;
  // max-height: "200px",
  overflow: auto;
  height: 49.5vh;

  @media (max-width: 1680px) {
    height: 47vh;
  }
  @media (max-width: 1440px) {
    height: 39vh;
  }
  @media (max-width: 1368px) {
    height: 37vh;
  }
  td:nth-child(6) {
    width: 165px;
    color: #000000;
  }
  th:nth-child(7) {
    text-align: left;
    padding-left: 5px;
  }
  th:nth-child(5) {
    width: 145px;
  }
  td:nth-child(7) {
    text-align: left;
    padding-left: 5px;
    width: 150px;
  }
  td:nth-child(2) {
    text-align: left;
  }
  td:nth-child(9) {
    text-align: left;
    color: #000000;
    width: 195px;
  }
  td:nth-child(10) {
    text-align: left;
    color: #000000;
    width: 190px;
  }
  td:nth-child(11) {
    text-align: left;
    color: #000000;
    width: 190px;
  }
  th:nth-child(12) {
    width: 160px;
    padding-right: 8px;
  }
  th:nth-child(8) {
    text-align: left;
    padding-left: 10px;
    width: 150px;
  }
  table thead {
    position: sticky;
    top: 0px;
    margin: 0 0 0 0;
  }

  table {
    border-spacing: 0;
    border: 0px solid black;
    width: 100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    tr:nth-child(odd) > td {
      background-color: #f2f2f2;
      opacity: 1;
    }
    th {
      font: normal normal bold 15px/19px Montserrat;
      color: #000000;
      min-width: 100px;
      padding: 5px 0px;
      padding-left: 10px;
    }
    th:nth-child(1) {
      min-width: 40px;
      // padding-left: 10px;
    }
    td,
    th {
      // padding: 5px;
      // text-align: center;
      height: 20px;
    }
    .textColor {
      color: #5696ae;
    }
    th:nth-child(3) > div {
      text-align: center;
      justify-content: center;
    }
    .down {
      width: 36px;
      padding-left: 5px;
    }
    td {
      margin: 0;
      border-bottom: 0px solid black;
      border-right: 0px solid black;
      font: normal normal 15px/19px Montserrat;
      // height: 76px;
      padding: 0px 10px;
      /* The secret sauce */
      /* Each cell should grow equally */
      // width: 1%;
      /* But "collapsed" cells should be as small as possible */
      &.collapse {
        width: 0.0000000001%;
      }

      // :last-child {
      //   border-right: 0;
      // }
      .marginLeft {
        margin-left: 5px;
      }
      .Charging {
        color: #6a9930;
      }
      .charging {
        color: #6a9930;
      }
      .CHARGING {
        color: #6a9930;
      }
      .UP {
        color: #6a9930;
      }
      .discharging {
        color: #5696ad;
      }
      .Discharging {
        color: #5696ad;
      }
      .DISCHARGING {
        color: #5696ad;
      }
      .Plugged,
      .CONNECTED {
        color: #e5972d;
      }
      .available {
        color: #b472b5;
      }
      .Available {
        color: #b472b5;
      }
      .AVAILABLE {
        color: #b472b5;
      }
      .Error {
        color: #a23b3e;
      }
      .ERROR {
        color: #a23b3e;
      }
      .alert {
        color: #a23b3e;
        margin: 3px 0px 5px;
      }
      .Alert {
        color: #a23b3e;
        margin: 3px 0px 5px;
      }
      .ALERT {
        color: #a23b3e;
        margin: 3px 0px 5px;
      }
      .DOWN {
        color: #a23b3e;
        margin: 3px 0px 5px;
      }
      .PLUGGED {
        color: #e5972d;
      }
      .plugged {
        color: #e5972d;
      }

      .OFFLINE {
        color: #353535;
      }
      .offline {
        color: #353535;
      }

      // .error{
      //   width: 32%;
      //   // margin: 0 auto;
      //   // padding-left: 10px;
      // }
      // .busError{
      //   width: 39%;
      //   // margin: 0 auto;
      //   // padding-left: 10px;
      // }
      .alert {
        width: 52px;
        padding-left: 0px;
        padding-bottom: 0px;
        margin: -12px 0px 0px;
      }
      // :last-child {
      //   border-right: 0;
      // }
    }
    @media screen and (max-width: 1399px) {
      th {
        font: normal normal bold 13px/15px Montserrat;
        padding: 0px 5px;
      }
      td {
        font: normal normal 13px/15px Montserrat;
        padding: 0px 5px;
      }
      table {
        width: 1230px;
      }
      th:nth-child(8) {
        text-align: left;
        padding-left: 0px;
        width: 150px;
      }
    }
    .flex-th {
      display: flex;
      justify-content: start;
      align-items: center;
    }
  }
`;
var checkCount = 0;
var rowdataObj;
var rowIddata = {};
var rowID;
var tID;
var chargerId;
var chargerTableId;
var TripCharge;
var downArrow = (
  <img
    src={require("assets/sortAscending_down.svg").default}
    className={cn(styles.marginLeft)}
  />
);
var upArrow = (
  <img
    src={require("assets/sortAscending_up.svg").default}
    className={cn(styles.marginLeft)}
  />
);
const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    if ({ ...rest }.checked === true || indeterminate === true) {
      checkCount = checkCount + 1;
    } else {
      checkCount = 0;
    }

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <label className={cn(styles.container)}>
          <input type="checkbox" ref={resolvedRef} {...rest} />
          <span className={cn(styles.checkmark)}></span>
        </label>
      </>
    );
  }
);

function Table({ columns, data }) {
  const [checkTrip, setCheckTrip] = useState(false);
  useEffect(() => {
    localStorage.setItem("selectedRowId", "");
    localStorage.setItem("selectedId", "");
    localStorage.setItem("checkedId", "");
  }, []);
  // Use the state and functions returned from useTable to build your UI
  // const dispatch = useDispatch();
  const shortingColumn = (column) => {
    setCheckTrip(column?.isSortedDesc);
    if (column?.id !== "selection" && column?.id !== "setChargingTime") {
      localStorage.setItem("shortingBy", column?.id);
    } else {
      let selectedId = selectedFlatRows.map((item) => item.id);
      if (selectedId.length > 0) {
        localStorage.setItem("checkedId", "");
      } else {
        localStorage.setItem("checkedId", "");
      }
      // }
    }
  };
  let shortId;
  if (localStorage.getItem("shortingBy") === null) {
    shortId = "nextTrip.date";
  } else {
    shortId = localStorage.getItem("shortingBy");
  }
  const sortees = React.useMemo(() => [
    {
      id: shortId,
      // desc: shortId === 'nextTrip.date' ? true : false
      desc:
        shortId === "nextTrip.date" && checkTrip === false
          ? true
          : checkTrip === false
          ? true
          : false,
    },
  ]);

  var resData = "";
  let localChargerID = localStorage.getItem("checkedId");

  if (
    localChargerID !== undefined &&
    localChargerID !== null &&
    localChargerID !== ""
  ) {
    if (localChargerID?.length > 0) {
      const split_string = localChargerID?.split(",");
      resData = split_string?.reduce(
        (acc, curr) => ((acc[curr] = true), acc),
        {}
      );
    } else {
      resData = "";
    }
  } else {
    resData = "";
  }
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,

    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      // defaultCanSort: true,
      initialState: {
        sortBy: sortees,
        selectedRowIds: resData,
      },
    },
    useSortBy,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              {/* <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} /> */}
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              {/* <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} /> */}
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );
  // debugger
  rowdataObj = selectedFlatRows.map((d) => d.original);

  rowID = selectedFlatRows.map((d) => d.original.id);

  TripCharge = selectedFlatRows.map((item) => ({
    id: item?.original?.id,
    trpCharge: item?.original?.tripChargePower,
    timezone: item?.original?.timezone,
  }));

  tID = selectedFlatRows.map((d) => d?.id);

  let ids = "";
  for (let i = 0; i < rowID.length; i++) {
    if (rowID[i] !== undefined) {
      ids += rowID[i] + ",";
    }
  }
  chargerId = ids.replace(/,\s*$/, "");

  let tableID = "";
  for (let i = 0; i < tID.length; i++) {
    if (tID[i] !== undefined) {
      tableID += tID[i] + ",";
    }
  }
  chargerTableId = tableID.replace(/,\s*$/, "");
  if (chargerTableId !== undefined && chargerTableId?.length >= 0) {
    localStorage.setItem("checkedId", chargerTableId);
  }
  // Render the UI for your table
  return (
    <>
      <table {...getTableProps()}>
        <thead style={{ backgroundColor: "#FFFFFF", zIndex: 3 }}>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, pos) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th key={pos}>
                  <div className="flex-th">
                    <span
                      className={cn(styles.tableHeader)}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      title={
                        column?.id !== "selection" &&
                        column?.id !== "setChargingTime"
                          ? "Sort"
                          : ""
                      }
                    >
                      <span
                        onClick={() => shortingColumn(column)}
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? "textColor"
                              : " textColor"
                            : ""
                        }
                      >
                        {column.render("Header") === "Next Trip"
                          ? "🔽"
                          : column.render("Header")}{" "}
                      </span>
                    </span>

                    {
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? downArrow
                            : upArrow
                          : ""}
                      </span>
                    }
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, pos) => {
                  return (
                    <td key={pos} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

function App(props) {
  const [confirmecondPopup, setConfirmecondPopup] = useState(false);
  const [confirmData, setConfirmData] = useState(false);
  const [arrayVal, setArrayVal] = useState(true);
  const postData = {};
  let ArrayData;

  const closePopup = useCallback((data) => {
    setConfirmecondPopup(data);
  }, []);

  var tableRowData;
  const confirmSave = useCallback((data) => {
    setConfirmData(data);
    if (data) {
      let tId = tableRowData.original.transactionId;
      postRequest("transactions/" + tId + "/instant-charge", postData)
        .then((res) => {
          if (res.status == 202) {
            console.log("CHARGER POST API success");
            setConfirmecondPopup(false);
          } else {
            console.error("err");
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
      // })
    }
  }, []);

  const postChargerData = useCallback(async (e) => {
    tableRowData = e;
    setConfirmecondPopup(true);
    if (e?.original?.setChargingTime?.name === "Manual Charge") {
      confirmSave(tableRowData);
    } else if (
      e?.original?.setChargingTime?.name === "Back To Scheduled" ||
      e?.original?.setChargingTime?.name === "Stop Charge"
    ) {
      deleteChargerData(tableRowData);
    }
  }, []);

  const deleteChargerData = async (e) => {
    let tId = e.original.transactionId;
    await deleteRequest("transactions/" + tId + "/instant-charge")
      .then((res) => {
        if (res.status == 202) {
          console.log("CHARGER DELETE API success");
        } else {
          console.error("err");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const [tripPopup, settripSchedule] = useState(false);
  const handleToggle = () => {
    settripSchedule(!tripPopup);
  };

  const blank = () => {};

  function capitalize(input) {
    return input
      ?.toLowerCase()
      .split(" ")
      .map((s) => s.charAt(0)?.toUpperCase() + s.substring(1))
      .join(" ");
  }

  if (
    (props?.filterdatas !== undefined && props?.filterdatas?.length > 0) ||
    (props?.filterChargerData !== undefined &&
      props?.filterChargerData?.length > 0)
  ) {
    let siteList = props?.filterdatas;
    let chargerList = props?.filterChargerData;
    if (
      props?.filterdatas?.length > 0 ||
      props?.filterChargerData?.length > 0
    ) {
      if (siteList?.length > 1 || chargerList?.length > 1) {
        if (
          siteList?.length >= chargerList?.length &&
          chargerList?.length > 0
        ) {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            chargerList?.some(
              ({ evseId, value }) =>
                obj?.id === value || obj?.charger?.chargerID === evseId
            )
          );
        } else if (siteList?.length >= chargerList?.length) {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            siteList?.some(
              ({ evseId, siteID }) =>
                obj?.site?.siteId === siteID ||
                obj?.charger?.chargerID === evseId
            )
          );
        } else if (chargerList?.length >= siteList?.length) {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            chargerList?.some(
              ({ evseId, value }) =>
                obj?.id === value || obj?.charger?.chargerID === evseId
            )
          );
        } else if (props?.filterdatas !== undefined) {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            props?.filterdatas?.some(
              ({ evseId, siteID }) =>
                obj?.site?.siteId === siteID ||
                obj?.charger?.chargerID === evseId
            )
          );
        } else {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            chargerList?.some(
              ({ evseId, value }) =>
                obj?.id === value || obj?.charger?.chargerID === evseId
            )
          );
        }
      } else {
        if (chargerList?.length == siteList?.length) {
          // ArrayData = props?.tableChargerData.filter(obj => chargerList.some(({ evseId, siteId }) => obj?.site?.siteId === siteId || (obj?.charger?.chargerID) === (evseId)));
          ArrayData = props?.tableChargerData?.filter((obj) =>
            chargerList?.some(
              ({ evseId, value }) =>
                obj?.id === value || obj?.charger?.chargerID === evseId
            )
          );
        } else if (siteList?.length > 0) {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            siteList?.some(
              ({ evseId, siteID }) =>
                obj?.site?.siteId === siteID ||
                obj?.charger?.chargerID === evseId
            )
          );
        } else if (chargerList?.length > 0) {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            chargerList?.some(
              ({ evseId, value }) =>
                obj?.id === value || obj?.charger?.chargerID === evseId
            )
          );
        } else {
          ArrayData = props?.tableChargerData?.filter((obj) =>
            props?.filterdatas?.some(
              ({ evseId, value }) =>
                obj?.id === value || obj?.charger?.chargerID === evseId
            )
          );
        }
      }
    } else {
      if (siteList?.length > 0) {
        ArrayData = props?.tableChargerData?.filter((obj) =>
          siteList?.some(
            ({ evseId, siteID }) =>
              obj?.site?.siteId === siteID || obj?.charger?.chargerID === evseId
          )
        );
      } else if (chargerList?.length > 0) {
        ArrayData = props?.tableChargerData?.filter((obj) =>
          chargerList?.some(
            ({ evseId, value }) =>
              obj?.id === value || obj?.charger?.chargerID === evseId
          )
        );
      } else {
        ArrayData = props?.tableChargerData;
        localStorage.removeItem("filterSite");
        localStorage.removeItem("filterCharger");
      }
    }
  } else {
    if (props?.alertState) {
      ArrayData = props.tableChargerData?.filter(
        (item, pos) =>
          item?.statusName === props?.alertFilter ||
          item?.nextTrip.error === true
      );
    } else if (props?.chargingState) {
      ArrayData = props.tableChargerData?.filter(
        (item) => item?.statusName?.toLocaleLowerCase() === "charging"
      );
    } else if (props?.dischargingState) {
      ArrayData = props.tableChargerData?.filter(
        (item) => item?.statusName?.toLocaleLowerCase() === "discharging"
      );
    } else {
      ArrayData = props?.tableChargerData;
    }
  }
  const columns = React.useMemo(
    () => [
      {
        Header: "Charger ",
        accessor: "charger.name",
        Cell: (props) => {
          return (
            <>
              <div
                className={cn(styles.col_charger, styles.col_charger_layout)}
              >
                <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                  {props.value}
                </h5>
                <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                  {props?.cell?.row?.original?.charger.port}
                </h5>
              </div>
            </>
          );
        },
      },
      {
        Header: () => <div style={{ textAlign: "center" }}>Status </div>,
        accessor: "status.type",
        Cell: (props) => {
          return (
            <>
              <div className={cn(styles.col_status, styles.col_status_layout)}>
                <img
                  src={
                    require("assets/" +
                      props?.cell?.row?.original?.status?.error1.toLowerCase() +
                      ".svg").default
                  }
                  alt="Rectangle 12"
                  className={cn(
                    styles.col_status_box,
                    props?.cell?.row?.original?.status?.error1,
                    styles.col_status_box_layout
                  )}
                />

                <h5
                  className={cn(
                    styles.h5_prop3,
                    styles.h5_prop3_layout,
                    props.value,
                    styles.blackColor
                  )}
                >
                  {props.value === "EV_EVSE_ERROR" ||
                  props.value === "EVSE_ERROR" ||
                  props.value === "EV_ERROR"
                    ? "Error"
                    : props.value === "DOWN"
                    ? "Disconnected"
                    : props.value === "UP"
                    ? "Connected"
                    : capitalize(props.value)}
                </h5>
              </div>
            </>
          );
        },
      },
      {
        Header: "Vehicle ",
        accessor: "vehicle.name",
        Cell: (props) => {
          return (
            <>
              {" "}
              <div className={cn(styles.vehicle, styles.vehicle_layout)}>
                <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                  {props.value}
                </h5>
                <h5
                  className={cn(
                    styles.h5_prop,
                    styles.h5_prop_vehicle,
                    styles.h5_prop_layout
                  )}
                >
                  {props?.cell?.row?.original?.vehicle?.model}
                </h5>
              </div>
            </>
          );
        },
      },
      {
        Header: "SoC ",
        accessor: "soc.current",
        Cell: (props) => {
          return (
            <>
              {props?.cell?.row?.original?.soc?.current === "" ||
              props?.cell?.row?.original?.soc?.current === undefined ? (
                ""
              ) : (
                <>
                  {props.value !== undefined ? (
                    <div className={cn(styles.col_soc, styles.col_soc_layout)}>
                      {
                        props?.cell?.row?.original?.vehicle?.name ===
                          undefined &&
                        (props?.cell?.row?.original?.soc?.current === "" ||
                          props?.cell?.row?.original?.soc?.current === 0) ? (
                          ""
                        ) : (
                          <div
                            className={cn(
                              styles.col_soc_flex,
                              styles.col_soc_flex_layout
                            )}
                          >
                            <div className={cn(styles.col_soc_flex_item)}>
                              <BatteryProgress
                                className={cn(
                                  styles.box20,
                                  styles.box20_layout
                                )}
                                bgcolor={props?.cell?.row?.original?.soc?.color}
                                progress={props.value}
                                height="22"
                                targetVal={
                                  props?.cell?.row?.original?.soc?.target
                                }
                              ></BatteryProgress>
                            </div>
                            <div className={cn(styles.col_soc_flex_spacer)} />
                            <h5
                              className={cn(
                                styles.highlights,
                                styles.highlights_layout
                              )}
                            >
                              {props.value}%
                            </h5>
                          </div>
                        )
                        // : ''}
                      }
                      {(props?.cell?.row?.original?.vehicle?.name !==
                        undefined &&
                        (props?.cell?.row?.original?.soc?.current === "" ||
                          props?.cell?.row?.original?.soc?.current ===
                            undefined ||
                          props?.cell?.row?.original?.soc?.target === "" ||
                          props?.cell?.row?.original?.soc?.target ===
                            undefined)) ||
                      props?.cell?.row?.original?.vehicle?.name ===
                        undefined ? (
                        ""
                      ) : (
                        <h5
                          className={cn(
                            styles.h5_target,
                            styles.h5_prop_layout
                          )}
                        >
                          Target : {props?.cell?.row?.original?.soc?.target}%
                        </h5>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          );
        },
      },
      {
        Header: () => <div>Site </div>,
        accessor: "site.address.street",
        Cell: (props) => {
          return (
            <>
              {props.value !== undefined &&
              props?.cell?.row?.original?.site?.address?.region !== undefined &&
              props?.cell?.row?.original?.site?.address?.countryCode ? (
                <div
                  className={cn(styles.col_charger, styles.col_charger_layout)}
                >
                  <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                    {props?.value}
                  </h5>
                  <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                    {props?.cell?.row?.original?.site?.address?.region +
                      ", " +
                      props?.cell?.row?.original?.site?.address?.countryCode}
                  </h5>
                </div>
              ) : (
                ""
              )}
            </>
          );
        },
      },
      {
        Header: () => <div style={{ textAlign: "center" }}>Ready By </div>,
        accessor: "readyBy",
        Cell: (props) => {
          return props.value === "Invalid date" ? "" : props?.value;
        },

        // Cell: (props) => {
        //   return (

        //     <> <div className={cn(styles.col_next_trip, styles.col_next_trip_layout)}>
        //       <div className={cn(styles.col_next_trip_item, styles.col_width_Ready)}>
        //         <div className={cn(styles.col_next_trip, styles.col_next_trip_left, styles.col_next_trip_layout)}>
        //           <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>

        //             {props.value}

        //           </h5>
        //         </div>
        //       </div>
        //     </div></>
        //   );
        // }
      },
      {
        Header: "Next Trip ",
        accessor: "nextTrip.date",
        Cell: (props) => {
          return (
            <>
              {" "}
              <div
                className={cn(
                  styles.col_next_trip,
                  styles.col_next_trip_layout
                )}
              >
                <div
                  className={cn(styles.col_next_trip_item, styles.col_width_50)}
                >
                  <div
                    className={cn(
                      styles.col_next_trip,
                      styles.col_next_trip_layout
                    )}
                  >
                    {(props?.cell?.row?.original?.vehicle !== undefined &&
                      props?.cell?.row?.original?.soc?.target === undefined &&
                      props?.cell?.row?.original?.soc?.target === "") ||
                    props?.cell?.row?.original?.vehicle?.name === undefined ||
                    props?.cell?.row?.original?.soc?.target === undefined ? (
                      ""
                    ) : (
                      <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                        {props.value}
                      </h5>
                    )}
                  </div>
                </div>
                {(props?.cell?.row?.original?.vehicle !== undefined &&
                  props?.cell?.row?.original?.soc?.target === undefined &&
                  props?.cell?.row?.original?.soc?.target === "") ||
                props?.cell?.row?.original?.vehicle?.name === undefined ||
                props?.cell?.row?.original?.soc?.target === undefined ? (
                  ""
                ) : (
                  <div
                    className={cn(
                      styles.col_next_trip_item1,
                      styles.col_ime_next_trip
                    )}
                  >
                    {props?.row?.original?.nextTrip?.error ? (
                      <img
                        src={require("assets/ic_report.svg").default}
                        alt="Rectangle 14"
                        className={cn(
                          styles.col_next_trip_box,
                          styles.col_next_trip_box_layout
                        )}
                      />
                    ) : (
                      <div />
                    )}
                  </div>
                )}
              </div>
            </>
          );
        },
      },
      {
        Header: () => (
          <div>
            Real-Time Power <span></span>
          </div>
        ),
        accessor: "realTimePower",
        Cell: (props) => {
          return props.value === undefined + " kW" ? "" : props.value;
        },
      },
      {
        Header: () => (
          <div style={{ textAlign: "center" }}>Session Net Energy </div>
        ),
        accessor: "sessionNetEnergy",
        cell: (props) => {},
      },
      {
        Header: () => <div style={{ textAlign: "center" }}>Session Time </div>,
        accessor: "sessionTime",
      },
      {
        Header: () => {
          return (
            <>
              {/* <Link to="/TripAndChargeSchedule">  */}
              {/* <div
                className={cn(
                  styles.group,
                  styles.group_layout,
                  checkCount > 0
                    ? styles.set_charge_time_active
                    : styles.set_charge_time
                )}
                onClick={checkCount > 0 ? handleToggle : blank}
              >
                <h5
                  style={{
                    color: "#ffffff",
                    padding: "5px 5px",
                    font: "normal normal 700 10px/13px Montserrat",
                  }}
                  className={cn(
                    styles.small_text_body,
                    styles.small_text_body_layout
                  )}
                >
                  {<span>{"SET CHARGE TIME"}</span>}
                </h5>
                {localStorage.setItem("TripSechedule", "Charging Schedule")}
              </div> */}
              {/* </Link> */}
            </>
          );
        },
        disableSortBy: true,
        accessor: "setChargingTime",
        Cell: (props) => {
          return (
            <>
              {" "}
              <div
                style={{ background: props.value.color }}
                className={cn(styles.group, styles.group_layout)}
                onClick={(e) => postChargerData(props.row)}
              >
                {props.value.name !== undefined &&
                props?.row?.original?.statusName != "alert" &&
                props?.row?.original?.statusName != "offline" &&
                props?.row?.original?.statusName != "available" &&
                props?.row?.original?.statusName != "down" &&
                props?.row?.original?.statusName != "" &&
                props?.row?.original?.nextTrip?.error != true ? (
                  <h5 className={cn(styles.h5_prop2, styles.h5_prop2_layout2)}>
                    {props.value.name}
                  </h5>
                ) : (
                  ""
                )}
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (arrayVal === true) {
      props.selectedRecordCb(ArrayData);
    }
  }, [ArrayData]);

  useEffect(() => {
    localStorage.setItem("selectedId", "");
    localStorage.setItem("checkedId", "");
  }, []);

  // console.log(abcVal)
  // ArrayData.map((item)=>{

  // })
  // const selectedRowKeys = Object.keys(selectedRows);
  return (
    <Styles>
      {ArrayData && (
        <>
          <Table
            columns={columns}
            data={ArrayData}
            style={{ height: "250px" }}
          />
        </>
      )}

      {/* result===undefined?data:result */}
      {tripPopup === true ? (
        <TripAndCharge
          popupState={handleToggle}
          tripChargeSchedule={TripCharge}
          charId={chargerId}
          rowData={rowdataObj}
        />
      ) : (
        ""
      )}
      {/* {confirmecondPopup === true ?
        <ConfrimBox closePopu={closePopup} confirmOk={confirmSave} />
        : ''
      } */}
    </Styles>
  );
}

export default App;
